import * as React from 'react';

const patternLeftInverted = (<svg width="329" height="657" viewBox="0 0 329 657" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_4518_55579)">
<path opacity="0.1" d="M164.073 82.0001C164.073 127.287 200.785 164 246.073 164H328.073V0.00012207H246.073C200.785 0.00012207 164.073 36.7128 164.073 82.0001Z" fill="#56B2FF"/>
<path opacity="0.15" d="M82.0728 164C36.7854 164 0.0727598 200.713 0.0727539 246C0.0727479 291.287 36.7854 328 82.0727 328H164.073V164H82.0728Z" fill="#56B2FF"/>
<path opacity="0.05" d="M246.073 492C291.36 492 328.073 455.287 328.073 410V164H164.073V410C164.073 455.287 200.785 492 246.073 492Z" fill="#56B2FF"/>
<path opacity="0.15" d="M246.073 656.199C200.785 656.199 164.073 619.486 164.073 574.199C164.073 528.911 200.785 492.199 246.073 492.199H328.073V656.199H246.073Z" fill="#56B2FF"/>
<path opacity="0.1" d="M0.0727539 410C0.0727593 364.713 36.7854 328 82.0728 328C127.36 328 164.073 364.713 164.073 410C164.073 455.287 127.36 492 82.0727 492C36.7854 492 0.0727485 455.287 0.0727539 410Z" fill="#56B2FF"/>
</g>
<defs>
<clipPath id="clip0_4518_55579">
<rect width="329" height="657" fill="white"/>
</clipPath>
</defs>
</svg>

);

export default patternLeftInverted; 
